import { Breadcrumbs, SettingsLayout, Spinner } from 'components'
import { Col, Row } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { useScreen, useTranslations } from 'hooks'

import { COLLECTIONS } from '__constants__'
import PropTypes from 'prop-types'
import { UserAdvancedForm, DeleteUserButton } from 'domains/User/components'
import { useGetUserInitialValues } from 'domains/User/hooks'

const SettingsProfileEditPage = (props) => {
  const { layoutProps } = props
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()
  /* Getting params from router */
  const params = useParams()

  const { xl, lg } = useScreen()
  /* Getting id from params */
  const { userId } = params

  /* Fetching user initial values */
  const [initialValues, loading] = useGetUserInitialValues(userId)

  /* Function to handle back click */
  const handleBack = () => navigate(-1)

  const headingProps = {
    title: t('My profile'),
    titleSize: 1
  }

  return (
    <SettingsLayout
      onBack={handleBack}
      breadcrumbs={<Breadcrumbs collection={COLLECTIONS.USERS} />}
      headingProps={headingProps}
      actions={<DeleteUserButton />}
      area="user">
      <Row>
        {loading ? (
          <Col span={24}>
            <Spinner height="70vh" text={t('User loading')} />
          </Col>
        ) : (
          <Col {...layoutProps}>
            <UserAdvancedForm
              initialData={initialValues}
              isBlockButtons={!xl}
              withNavigate={!lg}
            />
          </Col>
        )}
      </Row>
    </SettingsLayout>
  )
}

SettingsProfileEditPage.propTypes = {
  withoutHeader: PropTypes.bool,
  layoutProps: PropTypes.object
}

export default SettingsProfileEditPage
